import { ClassConstructor, classToPlain, plainToClass } from 'class-transformer';

import { Persistence } from './Persistence';

class SessionStoragePersistence<T> implements Persistence<T> {
  readonly type: ClassConstructor<T>;

  private key: string;

  constructor(param?: ClassConstructor<T> | string) {
    if (param) {
      if (typeof param === 'string') {
        this.key = param;
      } else {
        this.type = param;
      }
    }
  }

  useKey(key: string): void {
    this.key = key;
  }

  exists(): boolean {
    const data = window?.sessionStorage?.getItem(this.key);
    return data !== undefined && data !== null;
  }

  get(): T {
    const data = window?.sessionStorage?.getItem(this.key);
    if (data != null) {
      if (this.type) {
        return plainToClass(this.type, JSON.parse(data) || {});
      }
      return JSON.parse(data) as T;
    }
    return plainToClass(this.type, {});
  }

  set(instance: T): void {
    if (this.type && window?.sessionStorage !== undefined) {
      window.sessionStorage.setItem(this.key, JSON.stringify(classToPlain<T>(instance)));
    } else if (window?.sessionStorage !== undefined) {
      window.sessionStorage.setItem(this.key, JSON.stringify(instance));
    }
  }

  clear(): void {
    window?.sessionStorage?.removeItem(this.key);
  }
}

export default SessionStoragePersistence;
